import React from "react";
import { Button, Card, CardActions, CardHeader, CardContent, Box } from "@material-ui/core";
import styles from "./AccessDeniedPage.module.scss";
import { useNavigate } from "react-router";

interface AccessDeniedPageProps {
  appName?: string;
  email?: string;
  showLogout?: boolean;
  onLogout: () => void;
}

const AccessDeniedPage: React.FC<AccessDeniedPageProps> = ({ appName, email, onLogout, showLogout = true }) => {
  let deniedMessage,
    emailMessage = null;

  if (appName) {
    deniedMessage = <p>You have not been granted access to {appName}.</p>;
  } else {
    deniedMessage = <p>You have not been granted access to this page.</p>;
  }

  if (email) {
    emailMessage = (
      <p>
        Currently logged in as <span className="emph">{email}</span>.
      </p>
    );
  }

  const navigateTo = useNavigate();

  return (
    <Box className={styles.box}>
      <Card className={styles.card} variant="outlined">
        <CardHeader className={styles["card-header"]} title="Access Denied" />
        <CardContent>
          {deniedMessage}
          {emailMessage}
        </CardContent>
        {showLogout && (
          <CardActions>
            <Button size="large" color="inherit" onClick={onLogout}>
              Logout
            </Button>
          </CardActions>
        )}
        {!showLogout && (
          <CardActions>
            <Button size="large" color="inherit" onClick={() => navigateTo("/")}>
              Go back
            </Button>
          </CardActions>
        )}
      </Card>
    </Box>
  );
};

export default AccessDeniedPage;
